export default __webpack_public_path__ + "static/media/3521.1e2e4833.svg";